@if (config().title) {
  <div class="data-input-title">{{ config().title }}</div>
}

<ag-grid-angular
  class="ag-theme-basic-table data-input-grid"
  [rowData]="rowData()"
  [columnDefs]="columnDefs()"
  [gridOptions]="gridOptions()"
  (gridReady)="onGridReady($event)"
  (cellFocused)="onCellFocused($event)"
  (cellClicked)="onCellClicked($event)"
  (cellValueChanged)="onCellValueChanged($event)"
  (cellEditingStopped)="onCellEditingStopped()"
  (cellMouseOver)="onCellMouseOver($event)"
  (cellMouseOut)="onCellMouseOut()"
>
</ag-grid-angular>
